




























































































































import { computed, defineComponent, ref } from "@vue/composition-api";
import useContact from "@/store/useContact";
import ContactViewModel from "@/models/ContactViewModel";
import { VueTelInput } from "vue-tel-input";
import { profile as profilestore } from "@/store";

export default defineComponent({
    components: {
        VueTelInput,
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue")
    },
    setup(_, context) {
        const captainEmail = computed(() => {
            const email = profilestore.profile && profilestore.profile.userId;
            return email ? email.toLowerCase() : "";
        });
        const { add, nameRules, emailRules } = useContact({ captainEmail: captainEmail.value });

        const contactForm = ref<HTMLFormElement>();
        const valid = ref<boolean>(true);
        const showSuccess = ref<boolean>(false);
        const name = ref<string>("");
        const email = ref<string>("");
        const vueTel = {
            phone: "",
            props: {
                autoFormat: true,
                autoDefaultCountry: true,
                dropdownOptions: {
                    showDialCodeInList: true,
                    showDialCodeInSelection: false,
                    showFlags: true,
                    showSearchBox: true,
                    width: '300px',
                },
                ignoredCountries: ["KP", "RU"],
                inputOptions: {
                    autocomplete: 'on',
                    showDialCode: true,
                    placeholder: 'Enterphone number',
                    required: true,
                },
                mode: "international",
                preferredCountries: ["DK", "NO", "SE"],
                validCharactersOnly: true,
            }
        };
        const detectorsActive = ref<boolean>(false);
        const shorePowerActive = ref<boolean>(false);
        const smartplugActive = ref<boolean>(false);
        const mainDoorActive = ref<boolean>(false);
        const hatchActive = ref<boolean>(false);
        const voltageLowActive = ref<boolean>(false);
        const geofenceActive = ref<boolean>(false);
        const lowBatteryActive = ref<boolean>(false);
        const gatewayTamperedActive = ref<boolean>(false);
        const gatewayPowerlossActive = ref<boolean>(false);
        const detectorsSMSActive = ref<boolean>(false);
        const shorePowerSMSActive = ref<boolean>(false);
        const smartplugSMSActive = ref<boolean>(false);
        const mainDoorSMSActive = ref<boolean>(false);
        const hatchSMSActive = ref<boolean>(false);
        const voltageLowSMSActive = ref<boolean>(false);
        const geofenceSMSActive = ref<boolean>(false);
        const lowBatterySMSActive = ref<boolean>(false);
        const gatewayTamperedSMSActive = ref<boolean>(false);
        const gatewayPowerlossSMSActive = ref<boolean>(false);
        const isValid = ref(false);

        const phoneObject = function (object) {
            if (object.valid === true) {
                isValid.value = true;
            } else {
                isValid.value = false;
            }
        };

        const initSave = () => {
            if (contactForm.value) {
                const isFormValid = contactForm.value.validate();
                if (isFormValid && isValid.value) {
                    const newContact = new ContactViewModel();
                    newContact.name = name.value;
                    newContact.email = email.value;
                    newContact.active = true;
                    newContact.phoneNumber = vueTel.phone;
                    newContact.detectorsEmailActive = detectorsActive.value;
                    newContact.shorePowerEmailActive = shorePowerActive.value;
                    newContact.smartplugEmailActive = smartplugActive.value;
                    newContact.mainDoorEmailActive = mainDoorActive.value;
                    newContact.hatchEmailActive = hatchActive.value;
                    newContact.voltageLowEmailActive = voltageLowActive.value;
                    newContact.geofenceEmailActive = geofenceActive.value;
                    newContact.lowBatterySensorEmailActive = lowBatteryActive.value;
                    newContact.gatewayTamperedEmailActive = gatewayTamperedActive.value;
                    newContact.gatewayPowerlossEmailActive = gatewayPowerlossActive.value;
                    newContact.detectorsSMSActive = detectorsSMSActive.value;
                    newContact.shorePowerSMSActive = shorePowerSMSActive.value;
                    newContact.smartPlugSMSActive = smartplugSMSActive.value;
                    newContact.mainDoorSMSActive = mainDoorSMSActive.value;
                    newContact.hatchSMSActive = hatchSMSActive.value;
                    newContact.voltageLowSMSActive = voltageLowSMSActive.value;
                    newContact.geofenceSMSActive = geofenceSMSActive.value;
                    newContact.lowBatterySensorSMSActive = lowBatterySMSActive.value;
                    newContact.gatewayTamperedSMSActive = gatewayTamperedSMSActive.value;
                    newContact.gatewayPowerlossSMSActive = gatewayPowerlossSMSActive.value;
                    newContact.gsmConnectionLostEmailActive = false; // never allow contacts to have this active
                    newContact.gsmConnectionLostSMSActive = false; // never allow contacts to have this active
                    add(newContact).then(() => {
                        showSuccess.value = true;
                    });
                } else {
                    valid.value = isFormValid;
                }
            }
        };

        const successOk = () => {
            window.history.back();
        };

        return {
            contactForm,
            valid,
            name,
            email,
            vueTel,
            phoneObject,
            isValid,
            detectorsActive,
            shorePowerActive,
            smartplugActive,
            mainDoorActive,
            hatchActive,
            voltageLowActive,
            geofenceActive,
            lowBatteryActive,
            gatewayTamperedActive,
            gatewayPowerlossActive,
            detectorsSMSActive,
            shorePowerSMSActive,
            smartplugSMSActive,
            mainDoorSMSActive,
            hatchSMSActive,
            voltageLowSMSActive,
            geofenceSMSActive,
            lowBatterySMSActive,
            gatewayTamperedSMSActive,
            gatewayPowerlossSMSActive,
            nameRules,
            emailRules,
            showSuccess,
            successOk,
            initSave
        };
    },
});
